// extracted by mini-css-extract-plugin
export var actionButton = "_kr-0";
export var actionMenuContainer = "_kr-i";
export var bubble = "_kr-2";
export var bubbleActionMenu = "_kr-j";
export var bubbleContext = "_kr-6";
export var bubbleItems = "_kr-7";
export var customer = "_kr-3";
export var divider = "_kr-8";
export var fileList = "_kr-9";
export var hiddenComment = "_kr-o";
export var infoAbove = "_kr-a";
export var internal = "_kr-4";
export var lightActionButton = "_kr-1";
export var link = "_kr-b";
export var merchant = "_kr-5";
export var message = "_kr-c";
export var profilePicture = "_kr-e";
export var quillToolbarContainer = "_kr-f";
export var senderDate = "_kr-g";
export var senderDateCustomer = "_kr-h";
export var senderName = "_kr-d";
export var time = "_kr-k";
export var uploadedImage = "_kr-l";
export var username = "_kr-m";
export var xsmall = "_kr-n";